var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.tag)?_c('span',{staticClass:"session-tag",style:({
    backgroundColor: _vm.tags_getColor(_vm.tag),
  })},[_c('b-img',{attrs:{"src":_vm.tags_getIcon(_vm.tag),"alt":"","aria-hidden":"true"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.tags_getName(_vm.tag)))])],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06a9ecfc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/SessionTag.vue
// module id = 7NG2
// module chunks = 1